/**
 * i18n build-konfiguráció (demo-trust batch, party rank-4/c).
 *
 * A nyelvváltó (Header language-switcher) a `VITE_I18N_SWITCHER_ENABLED`
 * flaghez kötött. Amíg a nem-HU fordítások inkomplettek (74 HU-only kulcs),
 * a switcher ELREJTVE marad — ne kínáljunk olyan nyelv-váltást ami hiányos
 * UI-t ad. Default false: csak explicit opt-innal jelenik meg (teljes i18n után).
 * A HU-fallback (i18n.service `t()`) garantálja hogy nincs nyers-kulcs a UI-n.
 */
export function isLanguageSwitcherEnabled(): boolean {
  return import.meta.env.VITE_I18N_SWITCHER_ENABLED === 'true';
}
